import formSelect from './select/component.vue';
import fetchSelect from './fetchSelect/component.vue';
import fetchSuggestSelect from './fetchSuggestSelect/component.vue';
import formCheck from './check/component.vue';
import formRadio from './radio/component.vue';
import formText from './text/component.vue';
import formInput from './input/component.vue';
import errorMessage from './errorMessage/component.vue';
import step from './step/component.vue';
import stepGroup from './stepGroup/component.vue';

export default {
  'v-form-select': formSelect,
  'v-form-fetch-select': fetchSelect,
  'v-form-fetch-suggest-select': fetchSuggestSelect,
  'v-form-check': formCheck,
  'v-form-radio': formRadio,
  'v-form-text': formText,
  'v-form-input': formInput,
  'errorMessage': errorMessage,
  'v-form-step': step,
  'v-form-step-group': stepGroup,
};
